/* eslint-disable */
import type { GlobalAddress } from "../common/location.pb";
import type { RatePlan } from "./rate_plan.pb";
import type { Region } from "./region.pb";

/** Source which provided us with the address * */
export enum AddressSource {
  CUSTOMER = "CUSTOMER",
  IDOLOGY_IDV = "IDOLOGY_IDV",
  TLO_ADDRESS_SEARCH = "TLO_ADDRESS_SEARCH",
  GOVERNMENT_ID = "GOVERNMENT_ID",
  IDV_ATTEMPT = "IDV_ATTEMPT",
  CARD_ACTIVATION = "CARD_ACTIVATION",
  ALLOY_IDV = "ALLOY_IDV",
  PROOF_OF_ADDRESS_DOCUMENT = "PROOF_OF_ADDRESS_DOCUMENT",
  CARD_LINK = "CARD_LINK",
  /** @deprecated */
  PHONE_NUMBER = "PHONE_NUMBER",
}

/** How a customer has organized payments and assets across her accounts. */
export interface AccountPolicySettings {
  payment_alias_links?: AccountPolicySettingsAliasLink[];
}

export interface AccountPolicySettingsAliasLink {
  account_token?: string;
  /** @deprecated */
  hashed_alias_id?: number;
  hashed_alias_token?: string;
}

/** Address collected from different sources for an account */
export interface AddressLink {
  address?: GlobalAddress;
  address_source?: AddressSource;
  created_at?: number;
  address_token?: string;
}

export interface Account {
  token?: string;
  rate_plan?: RatePlan;
  rate_plan_accepted_at?: number;
  forced_business_at?: number;
  postal_code?: string;
  customer_address?: AddressLink;
  region?: Region;
}
